import {
  AppBar,
  Box,
  Button,
  Dialog,
  IconButton,
  Slide,
  Toolbar,
  Typography,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';
import { forwardRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PlatformService from '../../services/PlatformService';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FullReportPreviewDialog = ({ 
  open, 
  onClose, 
  reportHtml, 
  patientName = 'Patient' 
}) => {
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    if (open) {
      setLoading(true);
      // Small timeout to allow the dialog to animate and the iframe to be ready
      const timer = setTimeout(() => {
        setLoading(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [open]);

  const handlePrint = () => {
    if (!reportHtml) return;
    PlatformService.print(reportHtml, `Full_Report_${patientName.replace(/\s+/g, '_')}`);
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          bgcolor: '#f5f5f5',
        }
      }}
    >
      <AppBar sx={{ position: 'relative', bgcolor: '#1976d2' }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {t('Full Clinical Report Preview')} - {patientName}
          </Typography>
          <Button 
            autoFocus 
            color="inherit" 
            onClick={handlePrint}
            startIcon={<PrintIcon />}
            disabled={!reportHtml || loading}
          >
            {t('Print Report')}
          </Button>
        </Toolbar>
      </AppBar>
      
      <Box 
        sx={{ 
          height: 'calc(100vh - 64px)', 
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: { xs: 0, sm: 2, md: 4 }
        }}
      >
        {loading ? (
          <CircularProgress />
        ) : (
          <Box 
            sx={{ 
              width: '100%', 
              maxWidth: '900px', 
              height: '100%', 
              bgcolor: 'white',
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
              borderRadius: '8px',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <iframe
              title={t('Clinical Report Preview')}
              srcDoc={reportHtml}
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
              }}
            />
          </Box>
        )}
      </Box>
    </Dialog>
  );
};

export default FullReportPreviewDialog;
